module.exports = __webpack_public_path__ + "img/product-category-eternityrings@2x.fe22e68.webp";